import DefaultLayout from "../core/DefaultLayout";
import {Endpoint} from "../../constants/enums";
import {useFetch} from "../../helpers/hooks";
import {Divider, Grid, Typography, Container, Box} from "@material-ui/core";
import React, {useEffect, useMemo, useState} from "react";
import {fetchData, getImage} from "../../helpers/utils";
import ScrollContainer from "react-indiana-drag-scroll";
import {Link} from "react-router-dom";
import ExhibitCard from "../Exhibits/ExhibitCard";
import ExhibitMedia from "../Exhibits/ExhibitMedia";
import CompositionCard from "../Compositions/CompositionCard";
import ErrorBoundary from "../ErrorBoundary";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const getDatastreamProperties = (uuid, setData) => {
  const url = `${Endpoint.dataStreams}/${uuid}`
  fetchData(url).then((result) => {
    setData(result?.properties)
  })
}

const propMap = new Map([
	["ΟΝΟΜΑΣΙΑ",                                      1],
	["ΤΟΠΙΚΗ ΟΝΟΜΑΣΙΑ",                               2],
	["ΑΡΙΘΜΗΣΗ - Βιβλίο δωρητών",                     3],
	["ΕΙΔΟΣ / ΧΑΡΑΚΤΗΡΙΣΜΟΣ",                         4],
	["ΕΝΟΤΗΤΑ / ΘΕΜΑΤΙΚΗ ΚΑΤΗΓΟΡΙΑ (ΤΑΞΙΝΟΜΗΣΗ)",     5],
	["ΥΛΙΚΟ",                                         6],
	["ΚΑΤΑΣΚΕΥΑΣΤΗΣ / ΔΗΜΙΟΥΡΓΟΣ",                    7],
	["ΧΡΟΝΟΣ ΚΑΤΑΣΚΕΥΗΣ / ΔΗΜΙΟΥΡΓΙΑΣ",               8],
	["ΧΡΟΝΟΣ ΑΠΟΚΤΗΣΗΣ Ή ΧΡΗΣΗΣ",                     9],
	["ΤΟΠΟΣ ΚΑΤΑΣΚΕΥΗΣ / ΔΗΜΙΟΥΡΓΙΑΣ",                10],
	["ΤΟΠΟΣ ΧΡΗΣΗΣ / ΠΡΟΕΛΕΥΣΗΣ",                     11],
	["ΧΡΗΣΤΗΣ",                                       12],
	["ΤΡΟΠΟΣ ΑΠΟΚΤΗΣΗΣ - ΕΝΤΑΞΗ ΣΤΗ ΣΥΛΛΟΓΗ",         13],
	["ΜΑΡΤΥΡΙΑ ΔΩΡΗΤΗ",                               14]
]);


const ExhibitModal = (props) => {
  const {item, onClose} = props
  const url = `${Endpoint.containers}/${item.uuid}`
  const images = item.datastreams;
  const result = item;
  const classes = {
    close: {
        color: 'black'
    }
  }

  return <Container maxWidth={'xl'} spacing={0}>

          <Grid container direction="row" justify="space-between" alignItems={"center"} >

              {result?.label &&
              <Typography align={'center'} style={{ width: '100%'}} variant={'h4'}>
                  <div style={{ marginTop: '20px',  marginBottom: '20px', display: 'flex'}}>
                      <div style={{ margin: '0px auto'}}>
                          {result?.label}
                      </div>
                      <div style={{ right: '0px',  position: 'absolute%'}}>
                          <IconButton aria-label="close"  onClick={onClose}>
                              <CloseIcon classes={classes.black}/>
                          </IconButton>
                      </div>
                  </div>
              </Typography>
              }



          </Grid>

      <Grid container spacing={2} alignItems={'center'} alignContent={'center'} justifyContent={'center'}
          direction={'row'}>
      {images.map((img)=>{
            return <Grid item xs={6} align={'center'}>
                <ExhibitMedia image={img} result={result}/>
            </Grid>
          })
      }
      </Grid>
      <Grid container spacing={2} alignItems={'center'} alignContent={'center'} justifyContent={'center'}
          direction={'row'} style={{margin:'40px 0 0 0'}}>
      {result?.properties?.sort((a,b)=>{
        const aval = (a.label && propMap.get(a.label))? propMap.get(a.label):100;
        const bval = (b.label && propMap.get(b.label)) ? propMap.get(b.label):101;
        return Math.sign(aval-bval);
      }).filter((prop)=>{return prop.value && prop.label && propMap.get(prop.label)}).map((property)=>{
            return [
                <Grid key={property.key} item xs={4}>{property.label}</Grid>,
                <Grid key={property.key+'-val'} item xs={8}>{property.value?JSON.parse(property.value).values:""}</Grid>
            ]
        })}
    </Grid>
    <br/>
  </Container>
}


export default ExhibitModal